import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { CategoryProvider } from "@/context/CategoryContext";

import { Layout } from "@/components/Layout";
import { ScrollManager } from "@/components/ScrollManager";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import PaymentStatus from "@/pages/PaymentStatus";
import Privacy from "@/pages/Privacy";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProductForm from "@/pages/admin/AdminProductForm";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminDiscounts from "@/pages/admin/AdminDiscounts";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import DeliveryPayment from "@/pages/DeliveryPayment";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <CartProvider>
          <CategoryProvider>
            <BrowserRouter>
            {/* Marşrutlardan KƏNARDA: admin və çatdırılma səhifələrinə də aiddir. */}
            <ScrollManager />
            <Toaster position="top-center" richColors />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order/:orderNumber" element={<OrderConfirmation />} />
                <Route path="/login" element={<Auth mode="login" />} />
                <Route path="/register" element={<Auth mode="register" />} />
                <Route path="/account" element={<Account />} />
                <Route path="/privacy" element={<Privacy />} />

                {/* epoint ödəniş nəticəsi. "succsess" yazılışı da dəstəklənir —
                    epoint hesabında hansı variant yazılıbsa, işləyəcək. */}
                <Route path="/payment-success" element={<PaymentStatus variant="ok" />} />
                <Route path="/payment-succsess" element={<PaymentStatus variant="ok" />} />
                <Route path="/payment-error" element={<PaymentStatus variant="fail" />} />
              </Route>

              {/* Çatdırılma haqqının ödənişi — link müştəriyə göndərilir. */}
              <Route path="/delivery/:orderNumber" element={<DeliveryPayment />} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="products/new" element={<AdminProductForm />} />
                <Route path="products/:id" element={<AdminProductForm />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="discounts" element={<AdminDiscounts />} />
                <Route path="customers" element={<AdminCustomers />} />
              </Route>
            </Routes>
            </BrowserRouter>
          </CategoryProvider>
        </CartProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
